<script>
    import {addFormModal} from '../../Forms/ModalFormManager.svelte';

    export let policy_id;
    export let assessment_model;

    let assessment = assessment_model.store;

    let policy = assessment_model.getPolicyStatus(policy_id);

    function load_policy() {
        policy = assessment_model.getPolicyStatus(policy_id);
    }

    async function savePolicy(policy) {
        let updated_policy = await assessment_model.setPolicyStatus(policy);

        policy._rev = updated_policy.rev;
        policy._id = updated_policy.id;
    }

    function setRagStatus(color) {
        let clone = JSON.parse(JSON.stringify(policy))
        clone.rag_status = color;
        savePolicy(clone);
    }

    function editRecommendation() {
        let data = JSON.parse(JSON.stringify(policy))
        addFormModal({
            fields: [{
                label: 'Recommendation',
                name: 'recommendation',
                type: "textarea"
            }],
            data
        }).then((formData) => {
            savePolicy(formData);
        })
    }

    $: load_policy($assessment)
</script>

<tr>
    <td>{policy.name}</td>
    <td>
        <textarea class="textarea" bind:value={policy.policy_provided} on:blur={() => savePolicy(policy)}></textarea>
    </td>
    <td>
        <div class="buttons has-addons">
            <div class="button is-danger" class:is-light={policy.rag_status != "Red"} on:click={() => setRagStatus("Red")}>Red</div>
            <div class="button is-warning" class:is-light={policy.rag_status != "Amber"} on:click={() => setRagStatus("Amber")}>Amber</div>
            <div class="button is-success" class:is-light={policy.rag_status != "Green"} on:click={() => setRagStatus("Green")}>Green</div>
        </div>
    </td>
    <td>
        <textarea class="textarea" bind:value={policy.recommendation} on:blur={() => savePolicy(policy)}></textarea>
    </td>
</tr>